<template>
	<div>
		<div class="msg_box ">
			<div class="jorn_left">
				<div class="tech_title">走进同仁</div>
				<div v-for="(itme,i) in jornList" class="jorn_title" :key="i"
				:class="{'jorn_chon':className==itme.url}" @click="xin.goUrl(itme.url)">{{itme.name}}</div>
			</div>
			<div class="jorn_right">
				 <router-view></router-view>
			</div>
		</div>
	</div>
</template>

<script>
	import {mapState,mapMutations} from 'vuex'
	export default {
		data(){
			return {
				ziUrl:"",
				jornList:[
					{
						url:'/aboutUs/about',
						name:'公司介绍'
					},
					{
						url:'/aboutUs/joinUs',
						name:'加入我们'
					},
					{
						url:'/aboutUs/contactUs',
						name:'联系我们'
					},
					{
						url:'/aboutUs/flow',
						name:'订货流程'
					},
				]
			}
		},
		computed:{
			...mapState(['className'])
		},
		created() {
			
		},
		watch:{
			$route(to,frm){
				this.setclassName(to.path);
			}
		},
		methods:{
			...mapMutations(['setclassName'])
		}
	}
</script>

<style lang="scss" scoped="scoped">
	.msg_box{
		display: flex;
		justify-content: space-between;
	}
	.jorn_left{
		.jorn_title{
			cursor: pointer;
			line-height: 60px;
			font-size: 20px;
			color: #666666;
		}
		.jorn_chon{
			color: var(--themeColor);
		}
	}
	.jorn_right{
		width: 1000px;
	}
</style>
